import { EntryDashboardViewModel } from '../../virtual-terminal-generated';

export class EntryDashboardMainViewModel {
	model: EntryDashboardViewModel;

	constructor(model: EntryDashboardViewModel) {
		this.model = model;
	}
}
